import React from 'react';

function Features() {
  const features = [
    {
      icon: 'fas fa-coins',
      title: 'Parts Sociales',
      description: 'Achetez des parts sociales et devenez copropriétaire de la coopérative. Gagnez des dividendes sur vos investissements.'
    },
    {
      icon: 'fas fa-piggy-bank',
      title: "Objectifs d'Épargne",
      description: 'Définissez vos objectifs financiers et épargnez avec discipline grâce à nos plans personnalisés.'
    },
    {
      icon: 'fas fa-project-diagram',
      title: 'Projets Communautaires',
      description: 'Investissez dans des projets locaux (agriculture, commerce, énergie) et votez sur leur financement.'
    },
    {
      icon: 'fas fa-users',
      title: 'Système de Parrainage',
      description: 'Invitez vos proches et agrandissez la communauté. Bénéficiez d\'avantages pour chaque membre parrainé.'
    },
    {
      icon: 'fas fa-vote-yea',
      title: 'Vote Démocratique',
      description: 'Participez aux décisions importantes. Votre voix compte proportionnellement à vos parts sociales.'
    },
    {
      icon: 'fas fa-mobile-alt',
      title: '100% Mobile',
      description: 'Gérez vos investissements depuis votre téléphone. Simple, rapide et sécurisé.'
    }
  ];

  return (
    <section className="features" id="features">
      <h2>Pourquoi choisir Haivest?</h2>
      <div className="feature-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">
              <i className={feature.icon}></i>
            </div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;
